import React from 'react';

const WaitingCircleIcon: React.FC = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="11" cy="11" r="11" fill="#F79009" />
    <g clipPath="url(#clip0_29125_97755)">
      <path
        d="M11.0013 7.4974V10.9974L13.3346 12.1641M16.8346 10.9974C16.8346 14.2191 14.223 16.8307 11.0013 16.8307C7.77964 16.8307 5.16797 14.2191 5.16797 10.9974C5.16797 7.77573 7.77964 5.16406 11.0013 5.16406C14.223 5.16406 16.8346 7.77573 16.8346 10.9974Z"
        stroke="white"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_29125_97755">
        <rect width="14" height="14" fill="white" transform="translate(4 4)" />
      </clipPath>
    </defs>
  </svg>
);

export default WaitingCircleIcon;
